export const config = {
  title: 'Quick Submit',
  okText: 'Submit',
  width: 480,
  disabledUntilFilled: true,
  getNote: (context) =>
    context.moduleName === 'candidate'
      ? 'Note: Select a job to submit this candidate'
      : 'Note: Select a candidate to submit for this job',
  getFields: (context) =>
    context.moduleName === 'candidate'
      ? [
          {
            name: 'jobId',
            label: 'Job list',
            type: 'search-select',
            required: true,
            placeholder: 'Search Job ID/Job name (minimum 3 characters)',
            searchFetchKey: 'quickSubmitJobList',
          },
        ]
      : [
          {
            name: 'candidate',
            label: 'Candidate',
            type: 'search-select',
            required: true,
            placeholder: 'Search candidate name (minimum 3 character)',
            optionsKey: 'candidateOptions',
            searchFetchKey: 'quickSubmitCandidates',
            labelTemplate: '{applicantRefrenceId} - {firstName} {lastName} - ({lastdate})',
            valueKey: '_id',
          },
        ],
};
